import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Form,
  Row,
  Col,
  Spinner,
  Badge,
  Alert,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { default as Selector } from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const SecaoContasVinculadas = ({ codigoCadastro, onContaCriada }) => {
  const [contas, setContas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ges, setGes] = useState([]);
  const [geSelecionado, setGeSelecionado] = useState('');
  const [cadastrando, setCadastrando] = useState(false);
  const [ordenacao, setOrdenacao] = useState({ campo: 'codigo_grupo_empresa', direcao: 'asc' });

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  var contasOrdenadas = contas.slice().sort(function (a, b) {
    var campo = ordenacao.campo;
    var dir = ordenacao.direcao === 'asc' ? 1 : -1;
    var valA = a[campo];
    var valB = b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (campo === 'codigo_grupo_empresa' || campo === 'codigo_conta') return dir * (Number(valA) - Number(valB));
    return dir * String(valA).toLowerCase().localeCompare(String(valB).toLowerCase());
  });

  useEffect(() => {
    if (codigoCadastro) {
      carregarContas();
      if (ges.length === 0) carregarGEs();
    } else {
      setContas([]);
    }
  }, [codigoCadastro]);

  const carregarContas = async () => {
    if (!codigoCadastro) return;
    setLoading(true);
    try {
      const res = await api.listarContasCadUnico(codigoCadastro);
      setContas(res || []);
    } catch (e) {
      toast.error('Erro ao carregar contas vinculadas');
    } finally {
      setLoading(false);
    }
  };

  const carregarGEs = async () => {
    try {
      const res = await api.listarGruposEmpresaAdmin({ status: 'A' });
      setGes(res || []);
    } catch (e) {
    }
  };

  const handleCadastrarNoGE = async () => {
    if (!geSelecionado) {
      toast.warn('Selecione um Grupo de Empresa');
      return;
    }
    if (!codigoCadastro) return;
    setCadastrando(true);
    try {
      const res = await api.cadastrarCadUnicoNoGE(codigoCadastro, geSelecionado);
      const codigoConta = res && res.codigo_conta ? res.codigo_conta : '';
      toast.success(`Conta ${codigoConta} cadastrada no GE com sucesso!`);
      setGeSelecionado('');
      carregarContas();
      if (onContaCriada) onContaCriada();
    } catch (err) {
      const msg =
        (err && err.response && err.response.data && err.response.data.message) ||
        'Erro ao cadastrar no GE';
      toast.error(msg);
    } finally {
      setCadastrando(false);
    }
  };

  const badgeStatus = status => {
    if (status === '0') return <Badge variant="success">Ativo</Badge>;
    return <Badge variant="secondary">Inativo</Badge>;
  };

  if (!codigoCadastro) return null;

  return (
    <div>
      <Row className="align-items-end mb-3">
        <Col md={7}>
          <Form.Group className="mb-0">
            <Form.Label className="mb-1">Cadastrar em GE:</Form.Label>
            <Selector
              styles={customStyles}
              components={{ DropdownIndicator }}
              options={ges.map(function (ge) {
                return { value: ge.codigo, label: ge.codigo + ' — ' + ge.apelido };
              })}
              value={
                geSelecionado
                  ? ges
                      .filter(function (ge) { return String(ge.codigo) === String(geSelecionado); })
                      .map(function (ge) { return { value: ge.codigo, label: ge.codigo + ' — ' + ge.apelido }; })[0] || null
                  : null
              }
              onChange={function (selected) { setGeSelecionado(selected ? selected.value : ''); }}
              placeholder="Selecione um GE..."
              isClearable
              isSearchable
              noOptionsMessage={function () { return 'Nenhum GE encontrado'; }}
              menuPortalTarget={document.body}
            />
          </Form.Group>
        </Col>
        <Col md={5} className="mt-2 mt-md-0">
          <Button
            variant="primary"
            disabled={!geSelecionado || cadastrando}
            onClick={handleCadastrarNoGE}
          >
            {cadastrando && (
              <Spinner animation="border" size="sm" className="mr-1" />
            )}
            Cadastrar no GE
          </Button>
        </Col>
      </Row>

      <hr />

      {loading ? (
        <div className="text-center py-2">
          <Spinner animation="border" size="sm" />
          <span className="ml-2">Carregando contas...</span>
        </div>
      ) : contas.length === 0 ? (
        <Alert variant="info" className="mb-0">
          Nenhuma conta vinculada a este cadastro.
        </Alert>
      ) : (
        <div style={{ maxHeight: '40vh', overflowY: 'auto' }}>
        <Table striped bordered size="sm" className="mb-0">
          <thead style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
            <tr>
              <th style={thSortStyle} onClick={function () { handleOrdenacao('codigo_grupo_empresa'); }}>
                Grupo Empresa{iconeOrdenacao('codigo_grupo_empresa')}
              </th>
              <th style={thSortStyle} onClick={function () { handleOrdenacao('codigo_conta'); }}>
                Conta{iconeOrdenacao('codigo_conta')}
              </th>
              <th style={thSortStyle} onClick={function () { handleOrdenacao('apelido_conta'); }}>
                Apelido{iconeOrdenacao('apelido_conta')}
              </th>
              <th style={thSortStyle} onClick={function () { handleOrdenacao('status'); }}>
                Status{iconeOrdenacao('status')}
              </th>
            </tr>
          </thead>
          <tbody>
            {contasOrdenadas.map(function (c) {
              return (
                <tr key={c.codigo_grupo_empresa + '-' + c.codigo_conta}>
                  <td>
                    {c.codigo_grupo_empresa}
                    {c.apelido_ge ? ' — ' + c.apelido_ge : ''}
                  </td>
                  <td>{c.codigo_conta}</td>
                  <td>{c.apelido_conta}</td>
                  <td>{badgeStatus(c.status)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        </div>
      )}
    </div>
  );
};

export default SecaoContasVinculadas;
